import type { Router } from "vue-router";

import type { User, UserCapability } from "@/types/user";

export interface AdminAccessUserStore {
  hasCapability(capability: UserCapability): boolean;
  refreshSession(): Promise<User | null>;
}

export type AdminAccessUserStoreResolver =
  | AdminAccessUserStore
  | (() => AdminAccessUserStore);

function resolveUserStore(
  source: AdminAccessUserStoreResolver,
): AdminAccessUserStore {
  return typeof source === "function" ? source() : source;
}

export function installAdminAccessGuard(
  router: Router,
  userStore: AdminAccessUserStoreResolver,
): () => void {
  return router.beforeEach(async (to) => {
    const requiredCapability = to.meta.requiredCapability;
    if (!requiredCapability) return true;

    try {
      const sessionStore = resolveUserStore(userStore);
      const session = await sessionStore.refreshSession();
      if (!session || !sessionStore.hasCapability(requiredCapability)) {
        return { name: "profile" };
      }
      return true;
    } catch {
      return { name: "profile" };
    }
  });
}
